import {outter_post, outter_get,post} from 'common/js/axios-helper';
import {StatisticsApi} from "./constant/UrlMapper";
import {Loading} from 'element-ui';
import Server from 'common/conf/Server';
import ServerTwo from 'common/conf/ServerTwo';
import store from 'store';

const newServer = ServerTwo[process.env.NODE_ENV];
const oldServer = Server[process.env.NODE_ENV];

const host = "8886";
const host1 = "8883";
const host2 = "8885";



//统计模块
const selectByMemId = (data) => {
    return outter_post(StatisticsApi.selectByMemId, data, host1);
};
const teamtransactionList = (data) => {
    return outter_post(StatisticsApi.TeamTransactionList, data, host1);
};
const TeamMonthTransactionList = (data) => {
    return outter_post(StatisticsApi.TeamMonthTransactionList, data, host1);
};
const shoptransactiontj = (data) => {
    return outter_post(StatisticsApi.ShopTransactionTj, data, "9000");
};
const shopvolumetjList = (data) => {
    return outter_post(StatisticsApi.ShopVolumetjList, data, host1);
};
const shopvolumetjListTwo = (data) => {
    return post(StatisticsApi.ShopVolumetjListTwo, data, host1);
};
const agentvolumetjList = (data) => {
    return outter_post(StatisticsApi.AgentVolumetjList, data, "9000");
};
const shopactivationlookList = (data) => {
    return outter_post(StatisticsApi.ShopActivationLookList, data, host1);
};
const revenuestatisticsList = (data) => {
    return outter_post(StatisticsApi.RevenueStatisticsList, data, host2);
};

//饼图              代理商
const ecpieList = (data) => {
    return outter_post(StatisticsApi.EcPieList, data, host2);
};
//折线
const eclinechartList = (data) => {
    return outter_post(StatisticsApi.EcLineChartList, data, host2);
};
const ecagelinechartList = (data) => {
    return outter_post(StatisticsApi.EcAgeLineChartList, data, host2);
};

//饼图              商户
const merchantecpieList = (data) => {
    return outter_post(StatisticsApi.MerchantEcPieList, data, host2);
};
//折线
const merchanteclinechartList = (data) => {
    return outter_post(StatisticsApi.MerchantEcLineChartList, data, host2);
};
const merchantecagelinechartList = (data) => {
    return outter_post(StatisticsApi.MerchantEcAgeLineChartList, data, host2);
};





const getdaily = (data) => {
    return outter_post(StatisticsApi.Getdaily, data, host);
};
const getWithdrawalList = (data) => {
    return outter_post(StatisticsApi.GetWithdrawalList, data, host2);
};

const getStatisByAgent = (data) => {
    return outter_post(StatisticsApi.GetStatisByAgent, data, host2);
};

const gmvtop = (data) => {
    return outter_post(StatisticsApi.Gmvtop, data, host2);
};

const tranCountTOP = (data) => {
    return outter_post(StatisticsApi.TranCountTOP, data, host2);
};

const memCountTOP = (data) => {
    return outter_post(StatisticsApi.MemCountTOP, data, host2);
};

const tranCountCake = (data) => {
    return outter_post(StatisticsApi.TranCountCake, data, host2);
};

const getStatisByChnPlan = (data) => {
    return outter_post(StatisticsApi.GetStatisByChnPaln, data, host2);
};

const statisQpayInfoQry = (data) => {
    return outter_post(StatisticsApi.StatisQpayInfoQry, data, host2);
};

const statisTatAssets = (data) => {
    return outter_post(StatisticsApi.StatisTatAssets, data, host2);
};

const statisWithdraws = (data) => {
    return outter_post(StatisticsApi.StatisWithdraws, data, host2);
};

const statisGetAdjusts = (data) => {
    return outter_post(StatisticsApi.StatisGetAdjusts, data, host2);
};

const statisGetMemAccts = (data) => {
    return outter_post(StatisticsApi.StatisGetMemAccts, data, host2);
};



const statisGetUserStatis = (data) => {
    return outter_post(StatisticsApi.StatisGetUserStatis, data, host2);
};

const statisGetChnStatis = (data) => {
    return outter_post(StatisticsApi.StatisGetChnStatis, data, host2);
};

const countMdbFinTatacctDtl = (data) => {
    return outter_post(StatisticsApi.CountMdbFinTatacctDtl, data, '8892');
};

export const getUserId = () => {
    return store.getters.userId
};

const exportExcel = (data, url, port, base, newServer) => {

    let loadingInstanceget = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });

    data = {
        ...{
            tatId: store.getters.tatId,
            modifierId: getUserId() ? getUserId() : '',
        }, ...data
    };

    let params = '';

    for (let key in data) {
        if ((null == data[key] || undefined == data[key]) && key != 'remark') {
            data[key] = '';
        }
        params += key + '=' + data[key] + '&';
    }

    console.log(params)
    window.open((newServer ? newServer : oldServer )+ (port ? port : host2) + (base ? base : '/statis/') + url + '?' + params, '_blank');
    loadingInstanceget.close();
};



export default {
    selectByMemId,
    teamtransactionList,
    TeamMonthTransactionList,
    shoptransactiontj,
    shopvolumetjList,
    shopvolumetjListTwo,
    agentvolumetjList,
    shopactivationlookList,
    revenuestatisticsList,

    ecpieList,
    eclinechartList,
    ecagelinechartList,

    merchantecpieList,
    merchanteclinechartList,
    merchantecagelinechartList,

    getdaily,
    getWithdrawalList,
    getStatisByAgent,
    exportExcel,
    gmvtop,
    tranCountTOP,
    memCountTOP,
    tranCountCake,
    getStatisByChnPlan,
    countMdbFinTatacctDtl,
    statisQpayInfoQry,
    statisTatAssets,
    statisWithdraws,
    statisGetAdjusts,
    statisGetMemAccts,
    statisGetUserStatis,
    statisGetChnStatis
}



// WEBPACK FOOTER //
// ./src/service/StatisticsService.js